"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
interface ExperienceReportsIntro {
  headline: string;
  text: string;
}
export default function ExperienceReportsIntro(t0) {
  const $ = _c(8);
  const {
    headline,
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("mb-5 font-bold text-4xl text-primary sm:text-5xl", "sm:absolute sm:top-[50%] sm:left-12 sm:-translate-x-full sm:translate-y-[-50%] sm:text-right md:left-16", "break-words sm:w-[280px] lg:w-[300px] xl:w-[500px] xl:break-normal");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== headline) {
    t2 = <h2 className={t1} data-source="lc">{headline}</h2>;
    $[1] = headline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== text) {
    t3 = <p className="text-foreground text-lg" data-source="lc">{text}</p>;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="mb-12 grid sm:grid-cols-3 md:mb-20 lg:mb-28"><div className="relative col-span-2 bg-card p-8 sm:col-start-2 sm:pl-16 md:p-12 md:pl-24">{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}